import { forwardRef } from 'react';

const Input = forwardRef(function Input(
  {
    label,
    hint,
    error,
    leftIcon,
    rightIcon,
    className = '',
    id,
    ...props
  },
  ref
) {
  const inputId = id || (label ? `input-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[12px] font-semibold text-[var(--color-warm-700)] mb-1.5"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--color-warm-500)] pointer-events-none">
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`
            w-full h-10 bg-[var(--color-cream-50)]
            border ${error ? 'border-[var(--color-danger-500)]' : 'border-[var(--color-warm-200)]'}
            rounded-[var(--radius-md)]
            ${leftIcon ? 'pl-9' : 'pl-3'} ${rightIcon ? 'pr-9' : 'pr-3'}
            text-[14px] text-[var(--color-warm-900)]
            placeholder:text-[var(--color-warm-400)]
            hover:border-[var(--color-warm-300)]
            focus:outline-none focus:border-[var(--color-insight-500)] focus:ring-2 focus:ring-[var(--color-insight-100)]
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-colors
          `}
          {...props}
        />
        {rightIcon && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--color-warm-500)]">
            {rightIcon}
          </span>
        )}
      </div>
      {(hint || error) && (
        <p className={`text-[12px] mt-1.5 ${error ? 'text-[var(--color-danger-600)]' : 'text-[var(--color-warm-500)]'}`}>
          {error || hint}
        </p>
      )}
    </div>
  );
});

export default Input;
